function collectionSlider(selector, settings) {
  $(selector).slick(settings);
}

$(document).on("click",".close-pointer-popup", function (e) {
  e.preventDefault();
 $('.pointer-product--viewer').html('');
});
$(document).on(
  "change",
  ".size__variant_labels input[type='radio']",
  function () {
    var variantId = $(this).val();
    var item = {};
    var this_cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    item.id = variantId;
    item.quantity = 1;
    item.sections = this_cart
      .getSectionsToRender()
      .map((section) => section.id);
    var data = item;
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (response) {
        setTimeout(function () {
          this_cart.renderContents(response);
        }, 1000);
      },
    });
  }
);

$("hover-element").click(function (e) {
  e.preventDefault();
  let productUrl = $(this).data("product-url"),
    DesktopPositionX = $(this).attr('data-desktop-positionX'),
    DesktopPositionY = $(this).attr('data-desktop-positionY'),
    MobilePositionX= $(this).attr('data-mobile-positionX'),
    MobilePositionY= $(this).attr('data-mobile-positionY');

  $.ajax({
    type: "GET",
    url: productUrl,
    dataType: "json",
    success: function (res) {
      let product = res.product,image = product.image.src;
      console.log(product);
      let variant = product.variants[0];
      let htmlcard = `
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-pointer-popup">
        <g> 
          <path d="M16 8L8 16M8.00001 8L16 16" stroke="#000000" stroke-width="0.36" stroke-linecap="round" stroke-linejoin="round"></path>
        </g>
      </svg>
      <a href="/products/${product.handle}" class="pointer--product_card" 
         style="--pointer-x:${DesktopPositionX};
                --pointer-y:${DesktopPositionY};
                --mobile-position-x:${MobilePositionX};
                --mobile-position-y:${MobilePositionY};">
          <div class="pointer--card_image">
            <img src="${image}">
          </div>
  
        <div class="pointer--card_title">
          <h3 class="product--title">${product.title}</h3>
          <span class="money">${variant.price}</span>
        </div>
      </a>`;
      $('.pointer-product--viewer').html(htmlcard);
      $('.pointer-product--viewer').attr("style",`--pointer-x:${DesktopPositionX};
                --pointer-y:${DesktopPositionY};
                --mobile-position-x:${MobilePositionX};
                --mobile-position-y:${MobilePositionY};`);
    },
    error: function (xhr, status, error) {},
  });
});
